/**
 * Genera referencia dependiendo en que seccion se solcitie
 * @param {Number} arrayLength - Numero de facturas que se desean pagar (Seccion Pago de Facturas)
 * @param {string} concept - Concepto del pago (Seccion Referencia de anticipo)
 * @author KenzoSashida- ETE
 * @version 1.0.0 - Nov 28 2024 -
 */
export default function  generateReference (arrayLength = 0, concept=null) {
    let reference = ""
    const todayDate = new Date();
    const dateArray = {
        day: todayDate.getDate() < 10 ? `0${todayDate.getDate()}` : todayDate.getDate(),
        month: todayDate.getMonth()+1 < 10 ? `0${todayDate.getMonth()+1}` : todayDate.getMonth()+1,
        year: todayDate.getFullYear().toString().substr(-2),
        hour: todayDate.getHours() < 10 ? `0${todayDate.getHours()}` : todayDate.getHours(),
        minute: todayDate.getMinutes() < 10 ? `0${todayDate.getMinutes()}` : todayDate.getMinutes(),
        second: todayDate.getSeconds() < 10 ? `0${todayDate.getSeconds()}` : todayDate.getSeconds()
    }
    if (arrayLength) {
        reference = `${arrayLength}-${dateArray.day}${dateArray.month}${dateArray.year}-${dateArray.hour}${dateArray.minute}${dateArray.second}`.trim();
        return reference
    }
    let formatReference = "" // Asignarle formatReference un valor de string vacio
    switch (concept) {
        case "Contado": formatReference = "C"; break;
        case "Anticipo": formatReference = "A";break;
        default:
            throw new Error("That concept doesn't exist")

    }

    reference = `${formatReference}-${dateArray.day}${dateArray.month}${dateArray.year}-${dateArray.hour}${dateArray.minute}${dateArray.second}`.trim();
    return reference;
}